<template>
  <div class="content">
    <div class="md-layout">
      <div class="md-layout-item md-medium-size-100 md-size-75">
        <md-card>
          <md-card-header class="md-card-header-icon md-card-header-primary">
            <div class="card-text">
              <h4 class="title">
                {{ site.name }}
              </h4>
            </div>
          </md-card-header>
          <md-card-content>
            <div class="md-layout">
              <div class="md-layout-item md-small-size-100 md-size-33">
                <p>
                  <strong>Consultant</strong>
                  <br />
                  {{ site.consultantName }}
                </p>
              </div>

              <div class="md-layout-item md-small-size-100 md-size-33">
                <p>
                  <strong>Client</strong>
                  <br />
                  <router-link
                    :to="{
                      name: 'Client Details',
                      params: { clientId: site.clientId }
                    }"
                    >{{ site.clientName }}</router-link
                  >
                </p>
              </div>
            </div>
          </md-card-content>
        </md-card>
        <md-card>
          <md-card-header class="md-card-header-text md-card-header-primary">
            <div class="card-text">
              <h4 class="title">Buildings</h4>
            </div>
          </md-card-header>
          <md-card-content> <buildingList></buildingList> </md-card-content>
        </md-card>
      </div>
      <div class="md-layout-item md-medium-size-100 md-size-25"></div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import BuildingList from "./components/BuildingListing";

export default {
  components: {
    BuildingList
  },
  computed: {
    ...mapGetters({
      site: "portfolio/site"
    })
  },
  async created() {
    await this.$store.dispatch("portfolio/getSite", this.$route.params.siteId);
  },
  methods: {}
};
</script>

<style></style>
